/**
 * Feature flag for the Simulation V3 screen (NFR-9: flag off ⇒ zero change).
 *
 * IMPORTANT: this file must stay free of imports from the rest of the
 * simulationV3 module. App.js imports it directly to decide whether to
 * register the /masterplanograms/v3 route; pulling module internals here
 * would defeat the lazy code-split (the v3 chunk must not load while the
 * flag is off).
 *
 * Pattern mirrors REACT_APP_AI_SIMULATION_BUTTON /
 * REACT_APP_AI_SIMULATION_BUTTON_USER_ID in src/_services/common.service.js.
 */

const flagValue = process.env.REACT_APP_SIMULATION_V3 || 'false'

const allowedUserIds = (process.env.REACT_APP_SIMULATION_V3_USER_ID || '')
  .split(',')
  .map((id) => id.trim())
  .filter((id) => id)

/**
 * Returns true when the Simulation V3 screen is enabled.
 *
 * - `REACT_APP_SIMULATION_V3` unset or not "true" → always false.
 * - `REACT_APP_SIMULATION_V3_USER_ID` set (comma-separated ids) → the flag
 *   additionally requires the current user's id to be in the list.
 */
export const isSimulationV3Enabled = (
  userId?: string | number | null
): boolean => {
  if (flagValue !== 'true') return false
  if (allowedUserIds.length === 0) return true
  return userId !== null && userId !== undefined
    ? allowedUserIds.includes(String(userId))
    : false
}

/**
 * Feature flag that keeps the legacy Simulation V2 modal reachable
 * alongside V3. With V3 off this has no effect (V2 is already the only
 * path). With V3 on and this flag off, behavior is unchanged from before
 * this flag existed: the SIMULATOR tab opens V3 only, no way back to V2.
 * With both flags on, the SIMULATOR tab shows both a "Simulator" (V2) and
 * a "Simulator V3" button so either screen can be opened directly.
 */
const v2FlagValue = process.env.REACT_APP_SIMULATION_V2 || 'false'

export const isSimulationV2Enabled = (): boolean => v2FlagValue === 'true'
